/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Admins.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorApiOutContract,
  GetPatientsAutocompleteParams,
  GetPatientsParams,
  PatientAccountInformationAdminApiInContract,
  PatientAccountRestrictionAdminApiInContract,
  PatientAdminVisitTypeInfoApiOutContract,
  PatientCreditAmountAdminApiInContract,
  PatientGeneralInformationStaffApiInContract,
  PatientIdentityVerificationChannelApiInContract,
  PatientListItemStaffApiOutContract,
  PatientMergeAdminApiInContract,
  PatientStaffApiOutContract
} from '../pwrdbyQuickMDAdminsApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * # Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 404 | PatientNotFound | Patient with sent identifier is not found |
 * @summary Get a patient profile by their Id
 */
export const getPatientsPatientId = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PatientStaffApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdInfiniteQueryKey = (patientId?: string,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/patients/${patientId}`
    ] as const;
    }

export const getGetPatientsPatientIdQueryKey = (patientId?: string,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/patients/${patientId}`
    ] as const;
    }

    
export const getGetPatientsPatientIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientId>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientId>>> = ({ signal }) => getPatientsPatientId(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientId>>>
export type GetPatientsPatientIdInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientId>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientId>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientId>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a patient profile by their Id
 */

export function useGetPatientsPatientIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientId>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdInfiniteQueryOptions(patientId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get a patient profile by their Id
 */
export const prefetchGetPatientsPatientIdInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdInfiniteQueryOptions(patientId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientId>>> = ({ signal }) => getPatientsPatientId(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientId>>>
export type GetPatientsPatientIdQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientId<TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientId<TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientId<TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a patient profile by their Id
 */

export function useGetPatientsPatientId<TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get a patient profile by their Id
 */
export const prefetchGetPatientsPatientIdQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdQueryOptions(patientId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientId>>> = ({ signal }) => getPatientsPatientId(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientId>>>
export type GetPatientsPatientIdSuspenseQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a patient profile by their Id
 */

export function useGetPatientsPatientIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientId>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdSuspenseQueryOptions(patientId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientId>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientId>>> = ({ signal }) => getPatientsPatientId(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientId>>>
export type GetPatientsPatientIdSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientId>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientId>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientId>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a patient profile by their Id
 */

export function useGetPatientsPatientIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientId>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdSuspenseInfiniteQueryOptions(patientId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * # Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | OffsetNotValid | Offset is negative |
| 400 | CountNotValid | Count is zero or negative |
| 400 | BirthDateNotValid | BirthDate is not a valid date string |
| 400 | SearchValueNotValid | SearchValue is required when BirthDate is absent, and must be at least 3 characters |
 * @summary Get a filtered collection of patients
 */
export const getPatients = (
    params?: GetPatientsParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PatientListItemStaffApiOutContract[]>(
      {url: `https://admins-api.api.quick.md/api/v1/patients`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPatientsInfiniteQueryKey = (params?: GetPatientsParams,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/patients`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetPatientsQueryKey = (params?: GetPatientsParams,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/patients`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPatientsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatients>>>, TError = ErrorApiOutContract | void>(params?: GetPatientsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatients>>> = ({ signal }) => getPatients(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatients>>>
export type GetPatientsInfiniteQueryError = ErrorApiOutContract | void


export function useGetPatientsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatients>>>, TError = ErrorApiOutContract | void>(
 params: undefined |  GetPatientsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatients>>,
          TError,
          Awaited<ReturnType<typeof getPatients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatients>>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatients>>,
          TError,
          Awaited<ReturnType<typeof getPatients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatients>>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a filtered collection of patients
 */

export function useGetPatientsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatients>>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get a filtered collection of patients
 */
export const prefetchGetPatientsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(
 queryClient: QueryClient, params?: GetPatientsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsInfiniteQueryOptions(params,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsQueryOptions = <TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(params?: GetPatientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatients>>> = ({ signal }) => getPatients(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsQueryResult = NonNullable<Awaited<ReturnType<typeof getPatients>>>
export type GetPatientsQueryError = ErrorApiOutContract | void


export function useGetPatients<TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(
 params: undefined |  GetPatientsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatients>>,
          TError,
          Awaited<ReturnType<typeof getPatients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatients<TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatients>>,
          TError,
          Awaited<ReturnType<typeof getPatients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatients<TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a filtered collection of patients
 */

export function useGetPatients<TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get a filtered collection of patients
 */
export const prefetchGetPatientsQuery = async <TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(
 queryClient: QueryClient, params?: GetPatientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(params?: GetPatientsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatients>>> = ({ signal }) => getPatients(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatients>>>
export type GetPatientsSuspenseQueryError = ErrorApiOutContract | void


export function useGetPatientsSuspense<TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(
 params: undefined |  GetPatientsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsSuspense<TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsSuspense<TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a filtered collection of patients
 */

export function useGetPatientsSuspense<TData = Awaited<ReturnType<typeof getPatients>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatients>>>, TError = ErrorApiOutContract | void>(params?: GetPatientsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatients>>> = ({ signal }) => getPatients(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatients>>>
export type GetPatientsSuspenseInfiniteQueryError = ErrorApiOutContract | void


export function useGetPatientsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatients>>>, TError = ErrorApiOutContract | void>(
 params: undefined |  GetPatientsParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatients>>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatients>>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a filtered collection of patients
 */

export function useGetPatientsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatients>>>, TError = ErrorApiOutContract | void>(
 params?: GetPatientsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatients>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPatientsAutocomplete = (
    params?: GetPatientsAutocompleteParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/patients/autocomplete`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPatientsAutocompleteInfiniteQueryKey = (params?: GetPatientsAutocompleteParams,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/patients/autocomplete`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetPatientsAutocompleteQueryKey = (params?: GetPatientsAutocompleteParams,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/patients/autocomplete`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPatientsAutocompleteInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsAutocomplete>>>, TError = void | ErrorApiOutContract>(params?: GetPatientsAutocompleteParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsAutocompleteInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsAutocomplete>>> = ({ signal }) => getPatientsAutocomplete(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsAutocompleteInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsAutocomplete>>>
export type GetPatientsAutocompleteInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsAutocompleteInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsAutocomplete>>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetPatientsAutocompleteParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsAutocomplete>>,
          TError,
          Awaited<ReturnType<typeof getPatientsAutocomplete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsAutocompleteInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsAutocomplete>>>, TError = void | ErrorApiOutContract>(
 params?: GetPatientsAutocompleteParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsAutocomplete>>,
          TError,
          Awaited<ReturnType<typeof getPatientsAutocomplete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsAutocompleteInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsAutocomplete>>>, TError = void | ErrorApiOutContract>(
 params?: GetPatientsAutocompleteParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsAutocompleteInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsAutocomplete>>>, TError = void | ErrorApiOutContract>(
 params?: GetPatientsAutocompleteParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsAutocompleteInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsAutocompleteInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetPatientsAutocompleteParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsAutocompleteInfiniteQueryOptions(params,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsAutocompleteQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError = void | ErrorApiOutContract>(params?: GetPatientsAutocompleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsAutocompleteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsAutocomplete>>> = ({ signal }) => getPatientsAutocomplete(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsAutocompleteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsAutocomplete>>>
export type GetPatientsAutocompleteQueryError = void | ErrorApiOutContract


export function useGetPatientsAutocomplete<TData = Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetPatientsAutocompleteParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsAutocomplete>>,
          TError,
          Awaited<ReturnType<typeof getPatientsAutocomplete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsAutocomplete<TData = Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError = void | ErrorApiOutContract>(
 params?: GetPatientsAutocompleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsAutocomplete>>,
          TError,
          Awaited<ReturnType<typeof getPatientsAutocomplete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsAutocomplete<TData = Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError = void | ErrorApiOutContract>(
 params?: GetPatientsAutocompleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsAutocomplete<TData = Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError = void | ErrorApiOutContract>(
 params?: GetPatientsAutocompleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsAutocompleteQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsAutocompleteQuery = async <TData = Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetPatientsAutocompleteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsAutocompleteQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsAutocompleteSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError = void | ErrorApiOutContract>(params?: GetPatientsAutocompleteParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsAutocompleteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsAutocomplete>>> = ({ signal }) => getPatientsAutocomplete(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsAutocompleteSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsAutocomplete>>>
export type GetPatientsAutocompleteSuspenseQueryError = void | ErrorApiOutContract


export function useGetPatientsAutocompleteSuspense<TData = Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetPatientsAutocompleteParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsAutocompleteSuspense<TData = Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError = void | ErrorApiOutContract>(
 params?: GetPatientsAutocompleteParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsAutocompleteSuspense<TData = Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError = void | ErrorApiOutContract>(
 params?: GetPatientsAutocompleteParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsAutocompleteSuspense<TData = Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError = void | ErrorApiOutContract>(
 params?: GetPatientsAutocompleteParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsAutocompleteSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsAutocompleteSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsAutocomplete>>>, TError = void | ErrorApiOutContract>(params?: GetPatientsAutocompleteParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsAutocompleteInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsAutocomplete>>> = ({ signal }) => getPatientsAutocomplete(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsAutocompleteSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsAutocomplete>>>
export type GetPatientsAutocompleteSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsAutocompleteSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsAutocomplete>>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetPatientsAutocompleteParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsAutocompleteSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsAutocomplete>>>, TError = void | ErrorApiOutContract>(
 params?: GetPatientsAutocompleteParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsAutocompleteSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsAutocomplete>>>, TError = void | ErrorApiOutContract>(
 params?: GetPatientsAutocompleteParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsAutocompleteSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsAutocomplete>>>, TError = void | ErrorApiOutContract>(
 params?: GetPatientsAutocompleteParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsAutocomplete>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsAutocompleteSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putPatientsPatientIdAccountinfo = (
    patientId: string,
    patientAccountInformationAdminApiInContract: PatientAccountInformationAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/accountinfo`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: patientAccountInformationAdminApiInContract
    },
      options);
    }
  


export const getPutPatientsPatientIdAccountinfoMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdAccountinfo>>, TError,{patientId: string;data: PatientAccountInformationAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdAccountinfo>>, TError,{patientId: string;data: PatientAccountInformationAdminApiInContract}, TContext> => {

const mutationKey = ['putPatientsPatientIdAccountinfo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPatientsPatientIdAccountinfo>>, {patientId: string;data: PatientAccountInformationAdminApiInContract}> = (props) => {
          const {patientId,data} = props ?? {};

          return  putPatientsPatientIdAccountinfo(patientId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPatientsPatientIdAccountinfoMutationResult = NonNullable<Awaited<ReturnType<typeof putPatientsPatientIdAccountinfo>>>
    export type PutPatientsPatientIdAccountinfoMutationBody = PatientAccountInformationAdminApiInContract
    export type PutPatientsPatientIdAccountinfoMutationError = void | ErrorApiOutContract

    export const usePutPatientsPatientIdAccountinfo = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdAccountinfo>>, TError,{patientId: string;data: PatientAccountInformationAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPatientsPatientIdAccountinfo>>,
        TError,
        {patientId: string;data: PatientAccountInformationAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getPutPatientsPatientIdAccountinfoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putPatientsPatientIdGeneralinfo = (
    patientId: string,
    patientGeneralInformationStaffApiInContract: PatientGeneralInformationStaffApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/generalinfo`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: patientGeneralInformationStaffApiInContract
    },
      options);
    }
  


export const getPutPatientsPatientIdGeneralinfoMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdGeneralinfo>>, TError,{patientId: string;data: PatientGeneralInformationStaffApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdGeneralinfo>>, TError,{patientId: string;data: PatientGeneralInformationStaffApiInContract}, TContext> => {

const mutationKey = ['putPatientsPatientIdGeneralinfo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPatientsPatientIdGeneralinfo>>, {patientId: string;data: PatientGeneralInformationStaffApiInContract}> = (props) => {
          const {patientId,data} = props ?? {};

          return  putPatientsPatientIdGeneralinfo(patientId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPatientsPatientIdGeneralinfoMutationResult = NonNullable<Awaited<ReturnType<typeof putPatientsPatientIdGeneralinfo>>>
    export type PutPatientsPatientIdGeneralinfoMutationBody = PatientGeneralInformationStaffApiInContract
    export type PutPatientsPatientIdGeneralinfoMutationError = void | ErrorApiOutContract

    export const usePutPatientsPatientIdGeneralinfo = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdGeneralinfo>>, TError,{patientId: string;data: PatientGeneralInformationStaffApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPatientsPatientIdGeneralinfo>>,
        TError,
        {patientId: string;data: PatientGeneralInformationStaffApiInContract},
        TContext
      > => {

      const mutationOptions = getPutPatientsPatientIdGeneralinfoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update the credit amount for a specified patient.
 */
export const putPatientsPatientIdCredit = (
    patientId: string,
    patientCreditAmountAdminApiInContract: PatientCreditAmountAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/credit`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: patientCreditAmountAdminApiInContract
    },
      options);
    }
  


export const getPutPatientsPatientIdCreditMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdCredit>>, TError,{patientId: string;data: PatientCreditAmountAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdCredit>>, TError,{patientId: string;data: PatientCreditAmountAdminApiInContract}, TContext> => {

const mutationKey = ['putPatientsPatientIdCredit'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPatientsPatientIdCredit>>, {patientId: string;data: PatientCreditAmountAdminApiInContract}> = (props) => {
          const {patientId,data} = props ?? {};

          return  putPatientsPatientIdCredit(patientId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPatientsPatientIdCreditMutationResult = NonNullable<Awaited<ReturnType<typeof putPatientsPatientIdCredit>>>
    export type PutPatientsPatientIdCreditMutationBody = PatientCreditAmountAdminApiInContract
    export type PutPatientsPatientIdCreditMutationError = void | ErrorApiOutContract

    /**
 * @summary Update the credit amount for a specified patient.
 */
export const usePutPatientsPatientIdCredit = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdCredit>>, TError,{patientId: string;data: PatientCreditAmountAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPatientsPatientIdCredit>>,
        TError,
        {patientId: string;data: PatientCreditAmountAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getPutPatientsPatientIdCreditMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putPatientsPatientIdRestriction = (
    patientId: string,
    patientAccountRestrictionAdminApiInContract: PatientAccountRestrictionAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/restriction`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: patientAccountRestrictionAdminApiInContract
    },
      options);
    }
  


export const getPutPatientsPatientIdRestrictionMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdRestriction>>, TError,{patientId: string;data: PatientAccountRestrictionAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdRestriction>>, TError,{patientId: string;data: PatientAccountRestrictionAdminApiInContract}, TContext> => {

const mutationKey = ['putPatientsPatientIdRestriction'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPatientsPatientIdRestriction>>, {patientId: string;data: PatientAccountRestrictionAdminApiInContract}> = (props) => {
          const {patientId,data} = props ?? {};

          return  putPatientsPatientIdRestriction(patientId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPatientsPatientIdRestrictionMutationResult = NonNullable<Awaited<ReturnType<typeof putPatientsPatientIdRestriction>>>
    export type PutPatientsPatientIdRestrictionMutationBody = PatientAccountRestrictionAdminApiInContract
    export type PutPatientsPatientIdRestrictionMutationError = void | ErrorApiOutContract

    export const usePutPatientsPatientIdRestriction = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdRestriction>>, TError,{patientId: string;data: PatientAccountRestrictionAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPatientsPatientIdRestriction>>,
        TError,
        {patientId: string;data: PatientAccountRestrictionAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getPutPatientsPatientIdRestrictionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getPatientsPatientIdReport = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/report`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdReportInfiniteQueryKey = (patientId?: string,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/patients/${patientId}/report`
    ] as const;
    }

export const getGetPatientsPatientIdReportQueryKey = (patientId?: string,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/patients/${patientId}/report`
    ] as const;
    }

    
export const getGetPatientsPatientIdReportInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdReport>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdReportInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdReport>>> = ({ signal }) => getPatientsPatientIdReport(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdReportInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdReport>>>
export type GetPatientsPatientIdReportInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdReportInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdReport>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdReport>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdReportInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdReport>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdReport>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdReportInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdReport>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdReportInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdReport>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdReportInfiniteQueryOptions(patientId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdReportInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdReportInfiniteQueryOptions(patientId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdReportQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdReportQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdReport>>> = ({ signal }) => getPatientsPatientIdReport(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdReportQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdReport>>>
export type GetPatientsPatientIdReportQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdReport<TData = Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdReport>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdReport<TData = Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdReport>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdReport<TData = Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdReport<TData = Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdReportQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdReportQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdReportQueryOptions(patientId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdReportSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdReportQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdReport>>> = ({ signal }) => getPatientsPatientIdReport(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdReportSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdReport>>>
export type GetPatientsPatientIdReportSuspenseQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdReportSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdReportSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdReportSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdReportSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdReportSuspenseQueryOptions(patientId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdReportSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdReport>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdReportInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdReport>>> = ({ signal }) => getPatientsPatientIdReport(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdReportSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdReport>>>
export type GetPatientsPatientIdReportSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdReportSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdReport>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdReportSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdReport>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdReportSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdReport>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdReportSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdReport>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdReport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdReportSuspenseInfiniteQueryOptions(patientId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPatientsPatientIdIdentityverification = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/identityverification`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdIdentityverificationInfiniteQueryKey = (patientId?: string,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/patients/${patientId}/identityverification`
    ] as const;
    }

export const getGetPatientsPatientIdIdentityverificationQueryKey = (patientId?: string,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/patients/${patientId}/identityverification`
    ] as const;
    }

    
export const getGetPatientsPatientIdIdentityverificationInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdIdentityverificationInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>> = ({ signal }) => getPatientsPatientIdIdentityverification(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdIdentityverificationInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>
export type GetPatientsPatientIdIdentityverificationInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdIdentityverificationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdIdentityverificationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdIdentityverificationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdIdentityverificationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdIdentityverificationInfiniteQueryOptions(patientId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdIdentityverificationInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdIdentityverificationInfiniteQueryOptions(patientId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdIdentityverificationQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdIdentityverificationQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>> = ({ signal }) => getPatientsPatientIdIdentityverification(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdIdentityverificationQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>
export type GetPatientsPatientIdIdentityverificationQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdIdentityverification<TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdIdentityverification<TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdIdentityverification<TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdIdentityverification<TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdIdentityverificationQueryOptions(patientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetPatientsPatientIdIdentityverificationQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdIdentityverificationQueryOptions(patientId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdIdentityverificationSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdIdentityverificationQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>> = ({ signal }) => getPatientsPatientIdIdentityverification(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdIdentityverificationSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>
export type GetPatientsPatientIdIdentityverificationSuspenseQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdIdentityverificationSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdIdentityverificationSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdIdentityverificationSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdIdentityverificationSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdIdentityverificationSuspenseQueryOptions(patientId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdIdentityverificationSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>, TError = void | ErrorApiOutContract>(patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdIdentityverificationInfiniteQueryKey(patientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>> = ({ signal }) => getPatientsPatientIdIdentityverification(patientId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdIdentityverificationSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>
export type GetPatientsPatientIdIdentityverificationSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdIdentityverificationSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdIdentityverificationSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdIdentityverificationSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPatientsPatientIdIdentityverificationSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>>, TError = void | ErrorApiOutContract>(
 patientId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdIdentityverification>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdIdentityverificationSuspenseInfiniteQueryOptions(patientId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putPatientsPatientIdIdentityverificationVerify = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/identityverification/verify`, method: 'PUT'
    },
      options);
    }
  


export const getPutPatientsPatientIdIdentityverificationVerifyMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdIdentityverificationVerify>>, TError,{patientId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdIdentityverificationVerify>>, TError,{patientId: string}, TContext> => {

const mutationKey = ['putPatientsPatientIdIdentityverificationVerify'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPatientsPatientIdIdentityverificationVerify>>, {patientId: string}> = (props) => {
          const {patientId} = props ?? {};

          return  putPatientsPatientIdIdentityverificationVerify(patientId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPatientsPatientIdIdentityverificationVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof putPatientsPatientIdIdentityverificationVerify>>>
    
    export type PutPatientsPatientIdIdentityverificationVerifyMutationError = void | ErrorApiOutContract

    export const usePutPatientsPatientIdIdentityverificationVerify = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdIdentityverificationVerify>>, TError,{patientId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPatientsPatientIdIdentityverificationVerify>>,
        TError,
        {patientId: string},
        TContext
      > => {

      const mutationOptions = getPutPatientsPatientIdIdentityverificationVerifyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putPatientsPatientIdIdentityverificationResend = (
    patientId: string,
    patientIdentityVerificationChannelApiInContract: PatientIdentityVerificationChannelApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/identityverification/resend`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: patientIdentityVerificationChannelApiInContract
    },
      options);
    }
  


export const getPutPatientsPatientIdIdentityverificationResendMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdIdentityverificationResend>>, TError,{patientId: string;data: PatientIdentityVerificationChannelApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdIdentityverificationResend>>, TError,{patientId: string;data: PatientIdentityVerificationChannelApiInContract}, TContext> => {

const mutationKey = ['putPatientsPatientIdIdentityverificationResend'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPatientsPatientIdIdentityverificationResend>>, {patientId: string;data: PatientIdentityVerificationChannelApiInContract}> = (props) => {
          const {patientId,data} = props ?? {};

          return  putPatientsPatientIdIdentityverificationResend(patientId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPatientsPatientIdIdentityverificationResendMutationResult = NonNullable<Awaited<ReturnType<typeof putPatientsPatientIdIdentityverificationResend>>>
    export type PutPatientsPatientIdIdentityverificationResendMutationBody = PatientIdentityVerificationChannelApiInContract
    export type PutPatientsPatientIdIdentityverificationResendMutationError = void | ErrorApiOutContract

    export const usePutPatientsPatientIdIdentityverificationResend = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdIdentityverificationResend>>, TError,{patientId: string;data: PatientIdentityVerificationChannelApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPatientsPatientIdIdentityverificationResend>>,
        TError,
        {patientId: string;data: PatientIdentityVerificationChannelApiInContract},
        TContext
      > => {

      const mutationOptions = getPutPatientsPatientIdIdentityverificationResendMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postPatientsPatientIdIdentityverificationCallback = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/identityverification/callback`, method: 'POST', signal
    },
      options);
    }
  


export const getPostPatientsPatientIdIdentityverificationCallbackMutationOptions = <TError = ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdIdentityverificationCallback>>, TError,{patientId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdIdentityverificationCallback>>, TError,{patientId: string}, TContext> => {

const mutationKey = ['postPatientsPatientIdIdentityverificationCallback'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPatientsPatientIdIdentityverificationCallback>>, {patientId: string}> = (props) => {
          const {patientId} = props ?? {};

          return  postPatientsPatientIdIdentityverificationCallback(patientId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPatientsPatientIdIdentityverificationCallbackMutationResult = NonNullable<Awaited<ReturnType<typeof postPatientsPatientIdIdentityverificationCallback>>>
    
    export type PostPatientsPatientIdIdentityverificationCallbackMutationError = ErrorApiOutContract

    export const usePostPatientsPatientIdIdentityverificationCallback = <TError = ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdIdentityverificationCallback>>, TError,{patientId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPatientsPatientIdIdentityverificationCallback>>,
        TError,
        {patientId: string},
        TContext
      > => {

      const mutationOptions = getPostPatientsPatientIdIdentityverificationCallbackMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Retrieves information about a specific visit type for a patient, including credit details.
 */
export const getPatientsPatientIdVisitTypesVisitTypeId = (
    patientId: string,
    visitTypeId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PatientAdminVisitTypeInfoApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/visitTypes/${encodeURIComponent(String(visitTypeId))}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdVisitTypesVisitTypeIdInfiniteQueryKey = (patientId?: string,
    visitTypeId?: string,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/patients/${patientId}/visitTypes/${visitTypeId}`
    ] as const;
    }

export const getGetPatientsPatientIdVisitTypesVisitTypeIdQueryKey = (patientId?: string,
    visitTypeId?: string,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/patients/${patientId}/visitTypes/${visitTypeId}`
    ] as const;
    }

    
export const getGetPatientsPatientIdVisitTypesVisitTypeIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>>, TError = void | ErrorApiOutContract>(patientId: string,
    visitTypeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdVisitTypesVisitTypeIdInfiniteQueryKey(patientId,visitTypeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>> = ({ signal }) => getPatientsPatientIdVisitTypesVisitTypeId(patientId,visitTypeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId && visitTypeId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdVisitTypesVisitTypeIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>>
export type GetPatientsPatientIdVisitTypesVisitTypeIdInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdVisitTypesVisitTypeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    visitTypeId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitTypesVisitTypeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    visitTypeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitTypesVisitTypeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    visitTypeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves information about a specific visit type for a patient, including credit details.
 */

export function useGetPatientsPatientIdVisitTypesVisitTypeIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    visitTypeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdVisitTypesVisitTypeIdInfiniteQueryOptions(patientId,visitTypeId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves information about a specific visit type for a patient, including credit details.
 */
export const prefetchGetPatientsPatientIdVisitTypesVisitTypeIdInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string,
    visitTypeId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdVisitTypesVisitTypeIdInfiniteQueryOptions(patientId,visitTypeId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdVisitTypesVisitTypeIdQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError = void | ErrorApiOutContract>(patientId: string,
    visitTypeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdVisitTypesVisitTypeIdQueryKey(patientId,visitTypeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>> = ({ signal }) => getPatientsPatientIdVisitTypesVisitTypeId(patientId,visitTypeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId && visitTypeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdVisitTypesVisitTypeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>>
export type GetPatientsPatientIdVisitTypesVisitTypeIdQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdVisitTypesVisitTypeId<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    visitTypeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitTypesVisitTypeId<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    visitTypeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitTypesVisitTypeId<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    visitTypeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves information about a specific visit type for a patient, including credit details.
 */

export function useGetPatientsPatientIdVisitTypesVisitTypeId<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    visitTypeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdVisitTypesVisitTypeIdQueryOptions(patientId,visitTypeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves information about a specific visit type for a patient, including credit details.
 */
export const prefetchGetPatientsPatientIdVisitTypesVisitTypeIdQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string,
    visitTypeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdVisitTypesVisitTypeIdQueryOptions(patientId,visitTypeId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdVisitTypesVisitTypeIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError = void | ErrorApiOutContract>(patientId: string,
    visitTypeId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdVisitTypesVisitTypeIdQueryKey(patientId,visitTypeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>> = ({ signal }) => getPatientsPatientIdVisitTypesVisitTypeId(patientId,visitTypeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdVisitTypesVisitTypeIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>>
export type GetPatientsPatientIdVisitTypesVisitTypeIdSuspenseQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdVisitTypesVisitTypeIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    visitTypeId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitTypesVisitTypeIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    visitTypeId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitTypesVisitTypeIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    visitTypeId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves information about a specific visit type for a patient, including credit details.
 */

export function useGetPatientsPatientIdVisitTypesVisitTypeIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    visitTypeId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdVisitTypesVisitTypeIdSuspenseQueryOptions(patientId,visitTypeId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdVisitTypesVisitTypeIdSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>>, TError = void | ErrorApiOutContract>(patientId: string,
    visitTypeId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdVisitTypesVisitTypeIdInfiniteQueryKey(patientId,visitTypeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>> = ({ signal }) => getPatientsPatientIdVisitTypesVisitTypeId(patientId,visitTypeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdVisitTypesVisitTypeIdSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>>
export type GetPatientsPatientIdVisitTypesVisitTypeIdSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdVisitTypesVisitTypeIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    visitTypeId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitTypesVisitTypeIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    visitTypeId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdVisitTypesVisitTypeIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    visitTypeId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves information about a specific visit type for a patient, including credit details.
 */

export function useGetPatientsPatientIdVisitTypesVisitTypeIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    visitTypeId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdVisitTypesVisitTypeId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdVisitTypesVisitTypeIdSuspenseInfiniteQueryOptions(patientId,visitTypeId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * # Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | BadRequest | Invalid request parameters, patients not found, or merge validation failed |
| 401 | Unauthorized | Authentication failed |
| 500 | InternalServerError | Internal server error |
 * @summary Merges source patient accounts into a target patient account
 */
export const postPatientsTargetPatientIdMerge = (
    targetPatientId: string,
    patientMergeAdminApiInContract: PatientMergeAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(targetPatientId))}/merge`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientMergeAdminApiInContract, signal
    },
      options);
    }
  


export const getPostPatientsTargetPatientIdMergeMutationOptions = <TError = ErrorApiOutContract | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPatientsTargetPatientIdMerge>>, TError,{targetPatientId: string;data: PatientMergeAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postPatientsTargetPatientIdMerge>>, TError,{targetPatientId: string;data: PatientMergeAdminApiInContract}, TContext> => {

const mutationKey = ['postPatientsTargetPatientIdMerge'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPatientsTargetPatientIdMerge>>, {targetPatientId: string;data: PatientMergeAdminApiInContract}> = (props) => {
          const {targetPatientId,data} = props ?? {};

          return  postPatientsTargetPatientIdMerge(targetPatientId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPatientsTargetPatientIdMergeMutationResult = NonNullable<Awaited<ReturnType<typeof postPatientsTargetPatientIdMerge>>>
    export type PostPatientsTargetPatientIdMergeMutationBody = PatientMergeAdminApiInContract
    export type PostPatientsTargetPatientIdMergeMutationError = ErrorApiOutContract | void

    /**
 * @summary Merges source patient accounts into a target patient account
 */
export const usePostPatientsTargetPatientIdMerge = <TError = ErrorApiOutContract | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPatientsTargetPatientIdMerge>>, TError,{targetPatientId: string;data: PatientMergeAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPatientsTargetPatientIdMerge>>,
        TError,
        {targetPatientId: string;data: PatientMergeAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getPostPatientsTargetPatientIdMergeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * # Possible Errors
            
| HTTP status | ErrorCode | Description |
|--|--|--|
| 400 | BadRequest | Invalid request parameters or unmerge validation failed |
| 401 | Unauthorized | Authentication failed |
| 500 | InternalServerError | Internal server error |
 * @summary Unmerges a patient account, reversing a previous merge operation. If called with a main account that had other accounts merged into it, those accounts will be restored to their pre-merge state.
If called with a source account that was merged into another, it will be separated back into its own account.
 */
export const postPatientsPatientIdUnmerge = (
    patientId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/unmerge`, method: 'POST', signal
    },
      options);
    }
  


export const getPostPatientsPatientIdUnmergeMutationOptions = <TError = ErrorApiOutContract | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdUnmerge>>, TError,{patientId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdUnmerge>>, TError,{patientId: string}, TContext> => {

const mutationKey = ['postPatientsPatientIdUnmerge'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPatientsPatientIdUnmerge>>, {patientId: string}> = (props) => {
          const {patientId} = props ?? {};

          return  postPatientsPatientIdUnmerge(patientId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPatientsPatientIdUnmergeMutationResult = NonNullable<Awaited<ReturnType<typeof postPatientsPatientIdUnmerge>>>
    
    export type PostPatientsPatientIdUnmergeMutationError = ErrorApiOutContract | void

    /**
 * @summary Unmerges a patient account, reversing a previous merge operation. If called with a main account that had other accounts merged into it, those accounts will be restored to their pre-merge state.
If called with a source account that was merged into another, it will be separated back into its own account.
 */
export const usePostPatientsPatientIdUnmerge = <TError = ErrorApiOutContract | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdUnmerge>>, TError,{patientId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPatientsPatientIdUnmerge>>,
        TError,
        {patientId: string},
        TContext
      > => {

      const mutationOptions = getPostPatientsPatientIdUnmergeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    